import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { ArrowLeft } from "lucide-react";
import { get, ref } from "firebase/database";

import VehicleForm from "../forms/VehicleForm";
import { database } from "../../firebase/firebase";
import { Button } from "../../components/ui/button";

export default function EditVehiclePage() {
  const [data, setData] = useState<any>();
  const [key, setKey] = useState<string | null>(null);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      get(ref(database, `vehicles/${id}`)).then((snapshot: any) => {
        if (snapshot.exists()) {
          setData(snapshot.val());
          setKey(snapshot.key);
        } else {
          navigate("/admin-management");
        }
      });
    }
  }, [id, navigate]);

  const goBack = () => navigate("/admin-management/others/vehicles");

  return (
    <div className="min-h-screen bg-slate-950 px-4 py-6 text-white">
      <header className="mb-6 flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          className="text-white hover:bg-white/10"
          onClick={goBack}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-white/60">
            Veículos
          </p>
          <h1 className="text-2xl font-semibold">Editar veículo</h1>
        </div>
      </header>
      <VehicleForm id={key || undefined} vehicle={data} />
    </div>
  );
}
